import { Deserializable } from '.';

export class OrganizationAiModel implements Deserializable {
  id: number;
  name: string;
  organizationAlias: string;
  type: 'KNOWLEDGE_BASE' | 'N8N';
  temperature: string;
  topP: string;
  maxTokens: number;
  awsKnowledgeBaseId: string;
  knowledgeBaseId: string;
  aiModel: any;
  createdAt: Date;
  updatedAt: Date;
  active: boolean;
  promptTemplate: string;
  numberOfResults: number;
  genAiTips: { icon: string; title: string; prompt: string }[];

  aiModelId: number;

  webhookUrl: string;
  description: string;
  mappingAiPrompt: string;
  mappingAiSystemPrompt: string;
  mappingAiModelId: number;
  mappingAiModel: any;
  mainAiSystemPrompt: string;
  mainAiModelId: number;
  mainAiModel: any;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
